import React from 'react';
import Icon from '../../../components/AppIcon';

const FeatureCard = ({ iconName, title, description, accentColor = 'var(--color-primary)' }) => {
  return (
    <div className="group relative bg-card rounded-xl md:rounded-2xl p-6 md:p-8 shadow-sm hover:shadow-md transition-therapeutic border border-border">
      {/* Icon container */}
      <div className="flex items-center justify-center w-14 h-14 md:w-16 md:h-16 lg:w-20 lg:h-20 bg-primary/10 rounded-xl md:rounded-2xl mb-4 md:mb-6 transition-therapeutic group-hover:scale-110">
        <Icon 
          name={iconName} 
          size={32} 
          color={accentColor} 
          strokeWidth={2}
          className="transition-therapeutic"
        />
      </div>

      {/* Content */}
      <div className="space-y-2 md:space-y-3">
        <h3 className="text-lg md:text-xl lg:text-2xl font-heading font-semibold text-foreground">
          {title}
        </h3>
        <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
          {description}
        </p>
      </div>

      {/* Decorative element */}
      <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-primary/5 to-transparent rounded-bl-full opacity-0 group-hover:opacity-100 transition-therapeutic"></div>
    </div>
  );
};

export default FeatureCard;